// ── MD Photo Strip ──
(function() {
  'use strict';

  document.querySelectorAll('.md-photo-strip-section').forEach(function(section) {
    var sectionId = section.dataset.sectionId;
    var stripTrack = document.getElementById('mdStripTrack-' + sectionId);
    var lightbox = document.getElementById('mdLightbox-' + sectionId);
    var lightboxImg = document.getElementById('mdLightboxImg-' + sectionId);
    var closeBtn = section.parentElement.querySelector('[data-lightbox-close="' + sectionId + '"]');
    var pauseBtn = section.querySelector('[data-strip-pause="' + sectionId + '"]');

    if (!stripTrack) return;

    var isPaused = false;

    // Click to open lightbox
    stripTrack.querySelectorAll('.md-strip-photo').forEach(function(photo) {
      function open() {
        var src = photo.dataset.fullSrc || photo.src;
        lightboxImg.src = src;
        lightbox.classList.add('open');
        stripTrack.classList.add('paused');
        if (closeBtn) closeBtn.focus();
        document.addEventListener('keydown', onKey);
      }
      photo.addEventListener('click', open);
      photo.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
      });
    });

    function closeLightbox() {
      lightbox.classList.remove('open');
      lightboxImg.removeAttribute('src');
      if (!isPaused) stripTrack.classList.remove('paused');
      document.removeEventListener('keydown', onKey);
    }

    function onKey(e) {
      if (e.key === 'Escape') closeLightbox();
    }

    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
    if (lightbox) lightbox.addEventListener('click', function(e) { if (e.target === lightbox) closeLightbox(); });

    // Pause / Play
    if (pauseBtn) {
      pauseBtn.addEventListener('click', function() {
        isPaused = !isPaused;
        stripTrack.classList.toggle('paused', isPaused);
        var icon = pauseBtn.querySelector('.md-strip-pause-icon');
        var label = pauseBtn.querySelector('.md-strip-pause-label');
        if (icon) icon.textContent = isPaused ? '\u25B6' : '\u23F8';
        if (label) label.textContent = isPaused ? 'Play' : 'Pause';
        pauseBtn.setAttribute('aria-pressed', isPaused);
        pauseBtn.setAttribute('aria-label', isPaused ? 'Resume scrolling gallery' : 'Pause scrolling gallery');
      });
    }
  });
})();
